/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Contact_Open_NowInputs */

const en_contact_open_now = /** @type {(inputs: Contact_Open_NowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open now, until ${i?.time}`)
};

const pl_contact_open_now = /** @type {(inputs: Contact_Open_NowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teraz otwarte, do ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Open now, until {time}" |
*
* @param {Contact_Open_NowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_open_now = /** @type {((inputs: Contact_Open_NowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Open_NowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_open_now(inputs)
	return en_contact_open_now(inputs)
});